import EventEmitter from "eventemitter3";

class YoutubePlayer {

    constructor() {
        this.emitter = new EventEmitter();
        this._isPlaying = false;
        this._isPlayerReady = false;
        this._loop = false;
        this._mute = false;
        this._player = null;
        this.loadYoutubeAPI = this.loadYoutubeAPI.bind(this);
        this.playerReady = this.playerReady.bind(this);
        this.playerStateChange = this.playerStateChange.bind(this);
    }

    loadYoutubeAPI() {
        const apiScript = document.createElement('script');
        apiScript.type = 'text/javascript';
        apiScript.src = 'https://www.youtube.com/iframe_api';
        document.body.appendChild(apiScript);
        window.onYouTubeIframeAPIReady = () => {
            this.emitter.emit('ON_YOUTUBE_API_READY');
        };
    }

    createPlayer(tagName) {
        this._player = new YT.Player(tagName, {
            width: '1280',
            height: '720',
            videoId: this.videoId,
            playerVars: {
                'autoplay': 0,
                'rel': 0,
                'controls': 1,
                'autohide': 1,
                'showinfo': 0,
            },
            events: {
                'onReady': this.playerReady,
                'onStateChange': this.playerStateChange
            }
        });
    }

    playerReady() {
        this._isPlayerReady = true;
        this.emitter.emit('YOUTUBE_PLAYER_READY');
    }

    playerStateChange(event) {

        if (event.data == -1) {
            //unstarted
        }

        if (event.data == 0) {
            //ended
            this._isPlaying = false;
            if (this._loop) {
                this.seekTo(0);
                this.playVideo();
            }
        }

        if (event.data == 1) {
            //playing
            this._isPlaying = true;
        }

        if (event.data == 2) {
            //paused
            this._isPlaying = false;
        }
        if (event.data == 3) {
            //buffering
        }

        if (event.data == 5) {
            //video cued
        }
    }

    playVideo() {
        if (this._mute === true) {
            this.player.mute();
        }
        this.player.playVideo();
    }

    pauseVideo() {
        this.player.pauseVideo();
    }

    stopVideo() {
        this.player.stopVideo();
    }

    seekTo(time) {
        this.player.seekTo(time);
    }

    set videoId(id) {
        this._videoId = id;
    }

    set loop(loop) {
        this._loop = loop;
    }

    set mute(value) {
        this._mute = value;
    }

    get videoId() {
        return this._videoId;
    }

    get isPlaying() {
        return this._isPlaying;
    }

    get isPlayerReady() {
        return this._isPlayerReady;
    }

    get player() {
        return this._player;
    }
}

export default YoutubePlayer;